module.exports = __webpack_public_path__ + "img/2.07ac2e14.jpg";